import * as types from "./actionTypes";

export const loadRoomList = (list) => ({
  type: types.LOAD_ROOM_LIST,
  payload: list,
});

export const loadBuildingList = (list) => ({
  type: types.LOAD_BUILDING_LIST,
  payload: list,
});

export const loadAddReasonList = (list) => ({
  type: types.LOAD_ADDREASON_LIST,
  payload: list,
});

export const loadFloorsList = (list) => ({
  type: types.LOAD_FLOORS_LIST,
  payload: list,
});

export const setSiteId = (siteId) => ({
  type: types.SET_SITE_ID,
  payload: siteId,
});

export const loadSitesList = (list) => ({
  type: types.LOAD_SITES_LIST,
  payload: list,
});

// New action creators for admin location data
export const setAdminSiteId = (siteId) => ({
  type: types.SET_ADMIN_SITE_ID,
  payload: siteId,
});

export const loadAdminBuildings = (buildings) => ({
  type: types.LOAD_ADMIN_BUILDINGS,
  payload: buildings,
});

export const loadAdminFloors = (floors) => ({
  type: types.LOAD_ADMIN_FLOORS,
  payload: floors,
});

export const loadAdminRooms = (rooms) => ({
  type: types.LOAD_ADMIN_ROOMS,
  payload: rooms,
});

// Booking approval action creator
export const approveBooking = (bookingData) => ({
  type: types.APPROVE_BOOKING,
  payload: bookingData,
});

// Booking rejection action creator
export const rejectBooking = (bookingData) => ({
  type: types.REJECT_BOOKING,
  payload: bookingData,
});

export {
  setLoadingInstruments,
  loadFilteredInstruments,
  setInstrumentsError,
  fetchFilteredInstruments,
} from "./filteredInstruments.actions";
